import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import Partners from './components/Partners';
import Header from './components/Header';
import Games from './components/Games';
import BuyPage from './components/BuyPages/BuyPage';
import ArbBuyPage from './components/BuyPages/ArbBuyPage';
import SolBuyPage from './components/BuyPages/SolBuyPage';
import CexBuyPage from './components/BuyPages/CexBuyPage';
import EvmBuyPage from './components/BuyPages/EvmBuyPage';


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-b from-sky-100 to-blue-50 cursor-custom">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path='/memefi' element={<Partners/>} />
          <Route path="/buy" element={<BuyPage />} />
          <Route path="/games" element={<Games />} />
          <Route path="/buy/arbitrum" element={<ArbBuyPage />} />
          <Route path="/buy/solana" element={<SolBuyPage />} />
          <Route path="/buy/cex" element={<CexBuyPage />} />
          <Route path="/buy/evm" element={<EvmBuyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;